import {twMerge} from '../../../../common/twMerge';
import {putTiaraObjectProps} from '../../../../logging/putTiaraObjectProps';
import {CommonLayoutProps} from '../../type';

export function Landing({
  trackEventObj,
  children,
  className,
}: CommonLayoutProps) {
  return (
    <div
      {...putTiaraObjectProps(trackEventObj)}
      className={twMerge('flex w-full grow flex-col', className)}
    >
      {children}
    </div>
  );
}
